import { Injectable, EventEmitter } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { BaseService } from "../shared/services/base.service";
import * as config from '../shared/config/app.config';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {

  public catalogs = new BehaviorSubject<any>(null);
  catalogs$ = this.catalogs.asObservable();
  public catalogTypes = new BehaviorSubject<any>(null);
  catalogTypes$ = this.catalogTypes.asObservable();
  public paginationValues = new BehaviorSubject<any>(null);
  paginationValues$ = this.paginationValues.asObservable();
  public emitPaginationValue = new BehaviorSubject<any>(null);
  emitPaginationValue$ = this.emitPaginationValue.asObservable();
  public documentCategoryList = new BehaviorSubject<any>(null);
  documentCategoryList$ = this.documentCategoryList.asObservable();
  public serviceDetails = new BehaviorSubject<any>(null);
  serviceDetails$ = this.serviceDetails.asObservable();
  public documentList = new BehaviorSubject<any>(null);
  documentList$ = this.documentList.asObservable();
  public requestItemValues = new BehaviorSubject<any>(null);
  public accountInformation = new BehaviorSubject<any>(null);
  public backToDashBoardEmitter = new EventEmitter();
  public backtoDashboadItems = [];
  public categoryTypeList = [];

  constructor(public baseService: BaseService) { }

  public getCatalogs(baseSite) {
    const filter = {
      fields: 'DEFAULT',
    };
    const query = `${baseSite === 'vax' ? 'vaxserve':'vaccineShoppeUS'}ProductCatalog/Online/patientEducationCategories/m1`;
    this.baseService
      .get(config.CATALOGS + query, filter)
      .subscribe((res) => {
        this.catalogTypes.next(res);
      });
  }

  public getCatalogTypes(type?) {
    const filter = {
      fields: 'DEFAULT',
    };
    this.baseService
      .get(`${config.CATALOGSTYPE}${type}`, filter)
      .subscribe((res) => {
        this.catalogs.next(res);
      });
  }

  public getFAQ() {
    this.baseService.get(config.FAQ).subscribe((res) => {
    });
  }

  public setPaginationValues(data) {
    this.paginationValues.next(data);
  }

  public emitPagination(data) {
    this.emitPaginationValue.next(data);
  }

  public postPatientEducationRequest(params, userId, b2bUnitId) {
    return this.baseService.post(config.SUBMIT_REQUEST + '/' + userId + '/' + b2bUnitId + '?' + 'fields=DEFAULT', params);
  }

  public getAccountInformation(userId, b2bUnitId) {
    return this.baseService.get(config.USER_ACCOUNT + userId + '/b2bUnits/requestResource/' + b2bUnitId);
  }

  public getAllDocuments(params, filterSelected) {
    if(filterSelected == undefined || filterSelected == 'ALL'){
      this.baseService.get('/allDocuemnts', params).subscribe((res) => {
        this.documentList.next(res);
      });
    } else {
      this.baseService.get('/allDocuemnts/getDocumentsByCode/'+filterSelected, params).subscribe((res) => {
        this.documentList.next(res);
      });
    }
  }

  public getAllDocumentCategories(params) {
    this.baseService.get('/enumeration', params).subscribe((res) => {
      this.documentCategoryList.next(res);
    });
  }

  public mailDocuments(params) {
    return this.baseService.post('/allDocuemnts/email-mydocument?fields=DEFAULT',params);
  }

  public getServiceDetails() {
    this.baseService.get('allDocuemnts/support?fields=DEFAULT').subscribe((res) => {
      this.serviceDetails.next(res);
    });
  }

  public submitServiceDetails(params) {
    return this.baseService.post('allDocuemnts/support/service?fields=DEFAULT', params);
  }
}
